export default __webpack_public_path__ + "static/article-festive-fashion-f500db930525dcbacd9bf862af6fa397.jpg";